<template>
  <PuSkeletonTheme color="rgba(223, 223, 223, 35%)" highlight="rgba(223, 223, 223, 65%)">
    <card :color="color">
      <template v-slot:controls v-if="controls">
        <grab-control @grabstart="(e) => $emit('grabstart', e)" @grabend="(e) => $emit('grabend', e)"></grab-control>
        <kebab-menu>
          <action-link icon-left="icon-settings" size="small" class="mb-1" @click="$emit('configure')" v-if="editable">{{ $t('widgets.Dashboard.configure') }}</action-link>
          <action-link icon-left="icon-trash" size="small" @click="$emit('delete')">{{ $t('widgets.Dashboard.remove') }}</action-link>
        </kebab-menu>
      </template>

      <template v-slot:header>
        <div class="deposit-balance-header" v-if="settlements && !$apollo.queries.settlements.loading">
          <div class="deposit-balance-header__left text--medium">{{ settlements.partnerContract.partnerEntity.name ? settlements.partnerContract.partnerEntity.name : '——' }}</div>
          <div class="deposit-balance-header__right text--small mt-05">{{ settlements.partnerContract.partnerEntity.inn }}, {{ currencySymbol(settlements.partnerContract.currency) }}</div>
        </div>
        <div class="deposit-balance-header" v-else>
          <div class="deposit-balance-header__left text--medium"><PuSkeleton height="1.5rem" width="20rem" /></div>
          <div class="deposit-balance-header__right text--small mt-05"><PuSkeleton height="1.3rem" width="12rem" /></div>
        </div>
      </template>

      <div class="deposit-balance-content">
        <div class="deposit-balance-content__left">
          <div class="text-color-space-light text--uppercase text--bold mb-05" style="opacity: .6;">{{$t('widgets.DepositBalance.balance')}}</div>
          <div class="text--large text--medium py-05" v-if="settlements && !$apollo.queries.settlements.loading">{{toCurrency(settlements.partnerContract.balance, settlements.partnerContract.currency)}}</div>
          <div class="text--large text--medium py-05" v-else><PuSkeleton height="1.3rem" width="12rem" /></div>
        </div>
        <div class="deposit-balance-content__right">
          <div class="text-color-space-light text--uppercase text--bold mb-05" style="opacity: .6;">{{$t('widgets.DepositBalance.forecastBalance')}}</div>
          <div class="corner-rounded py-05 px-1 text--medium d-inline-block" :class="settlements.forecastBalance > 0 ? 'bg-green' : 'bg-error'" v-if="settlements && !$apollo.queries.settlements.loading">{{toCurrency(settlements.forecastBalance, settlements.partnerContract.currency)}}</div>
          <div class="corner-rounded py-05 text--medium d-inline-block" v-else><PuSkeleton height="2rem" width="6rem" /></div>
        </div>
      </div>
    </card>
  </PuSkeletonTheme>
</template>

<script>
import Card from '@/ui/slots/Card'

import KebabMenu from '@/ui/controls/KebabMenu'
import ActionLink from '@/ui/controls/ActionLink'
import GrabControl from '@/ui/controls/GrabControl'

import toCurrency from '@/mixins/toCurrency'
import currContractId from '@/mixins/currContractId'
import currencySymbol from '@/mixins/currencySymbol'
import hasActiveContracts from '@/mixins/hasActiveContracts'

import { SettlementsGQL } from '@/graphql/queries'

export default {
  name: 'DepositBalance',

  props: {
    color: {
      type: String,
      default: 'dark'
    },

    controls: {
      type: Boolean,
      default: false
    },

    editable: {
      type: Boolean,
      default: false
    },

    contract: {
      type: Number,
      default: null
    }
  },

  mixins: [toCurrency, currContractId, currencySymbol, hasActiveContracts],

  apollo: {
    settlements: {
      query: SettlementsGQL,
      variables () {
        return {
          params: {
            partnerContractId: +this.contract ? +this.contract : +this.currContractId
          }
        }
      },
      update: data => data.merchant.settlements,
      skip () {
        if (this.contract) {
          return !this.contract
        }

        if (this.currContractId) {
          return !this.currContractId
        }

        return true
      }
    }
  },

  components: {
    Card,
    KebabMenu,
    ActionLink,
    GrabControl
  }
}
</script>

<style lang="scss">
.deposit-balance-content {
  display: flex;

  &__left {
    width: 60%;
  }

  &__right {
    width: 40%;
  }
}

.deposit-balance-header {}
</style>
